<template>
  <div class="google-translate-container">
    <div id="google_translate_element" aria-hidden="true"></div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

function loadGoogleTranslateScript() {
    if (!document.getElementById("google-translate-script")) {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.head.appendChild(script);
    }

    window.googleTranslateElementInit = googleTranslateElementInit;

    customizeGoogleTranslateDropdown();

}

function googleTranslateElementInit() {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
      },
      "google_translate_element"
    );

    waitForGoogleTranslate();
}

function waitForGoogleTranslate() {
    const targetNode = document.querySelector(".google-translate-container");
    if (!targetNode) return;

    const observer = new MutationObserver((mutations, obs) => {
      const parentDiv = targetNode.querySelector(".goog-te-gadget");
      if (parentDiv) {
        obs.disconnect();
        customizeGoogleTranslateDropdown();
      }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
}

function customizeGoogleTranslateDropdown() {
    const parentDiv = document.querySelector(".google-translate-container .goog-te-gadget");
    if (parentDiv) {
        parentDiv.childNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() === "Powered by") {
                node.remove();
            }
        });
     }
}

onMounted(() => {
    loadGoogleTranslateScript();
});
</script>


